import PhotoDocumentsDelete from './PhotoDocumentsDelete';

export default PhotoDocumentsDelete;
